<template>
  <div id="home">
    <div id="intro">
      <div class="container">
        <h1>{{ parseTranslation(HOME_TITLE) }}</h1>

        <p>{{ parseTranslation(CAPTION) }}</p>

        <div id="option-btns">
          <button :class="{ active: option === 'upload' }" @click="option = 'upload'">
            {{ parseTranslation(UPLOAD_FILE) }}
          </button>

          <button
            :class="{ active: option === 'templates' }"
            @click="option = 'templates'"
          >
            {{ parseTranslation(TEMPLATES) }}
          </button>

          <button :class="{ active: option === 'create' }" @click="option = 'create'">
            {{ parseTranslation(CREATE_NEW) }}
          </button>
        </div>

        <transition class="fade" name="fade" mode="out-in">
          <Uploader v-if="option === 'upload'" />
          <CreateNew v-if="option === 'create'" />
          <Template v-if="option === 'templates'" />
        </transition>
      </div>
    </div>

    <SurveyDataTable />

    <Loader v-if="isLoading" class="loading" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Loader from '@/components/loading/Loader'

import Uploader from './Uploader'
import CreateNew from './CreateNew'
import Template from './Templates'
import SurveyDataTable from './SurveyDataTable'

import * as translationHome from './index.translations'

const { default: translations, ...translationKeys } = translationHome

export default {
  name: 'home',

  data() {
    return {
      option: 'upload',
      translations,
      ...translationKeys,
    }
  },

  components: {
    Uploader,
    CreateNew,
    SurveyDataTable,
    Template,
    Loader,
  },

  computed: {
    ...mapGetters(['isLoading']),
  },
}
</script>

<style lang="scss" scoped>
.loading {
  width: calc(100% + 40px);
  height: calc(100% + 107px);
  top: -67px;
  left: -20px;
}

#home {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
#intro {
  text-align: center;
  padding: 60px 0;
  transition: all 1s ease-in-out;
  h1 {
    @include tipography(30);
    font-weight: bold;
    @include d(s) {
      font-size: 1.7rem;
    }
  }
  p {
    @include tipography(16);
    margin: 15px 0px 30px;
  }
  .light & {
    h1,
    p {
      color: black;
    }
  }
}
#option-btns {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  button {
    background: $gray-light;
    border: none;
    padding: 8px 25px;
    cursor: pointer;
    @include tipography(16);
    text-transform: uppercase;
    letter-spacing: 3px;
    font-weight: bold;
    color: $gray-2;
    transition: all 0.5s ease;
    white-space: nowrap;
    @include d(s) {
      font-size: 0.7rem;
    }
    &:nth-of-type(1) {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
    &:nth-of-type(3) {
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
    }
    &:hover {
      background: $gray;
      color: $white;
    }
    &.active {
      background: $blue;
      color: $white;
    }

    &:focus {
      outline: none;
    }
  }
}

@media (max-width: 575.98px) {
  #option-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 40px;

    button {
      background: $gray-light;
      border: none;
      padding: 10px 45px;
      cursor: pointer;
      @include tipography(16);
      text-transform: uppercase;
      letter-spacing: 3px;
      font-weight: bold;
      color: $gray-2;
      transition: all 0.5s ease;
      white-space: nowrap;
      border-radius: 30px;
      width: 220px;
      margin-bottom: 10px;
      @include d(s) {
        font-size: 0.7rem;
      }
    }
  }
}
</style>
